import ReactDOM from "react-dom";

export default function PopupWrapper({ children }) {
  const portalRoot = document.getElementById("popup-wrapper");

  if (!portalRoot) return null;

  return ReactDOM.createPortal(children, portalRoot);
}
